import { render, staticRenderFns } from "./CollectionVideoPreview.vue?vue&type=template&id=917ad63e&scoped=true&"
import script from "./CollectionVideoPreview.vue?vue&type=script&lang=js&"
export * from "./CollectionVideoPreview.vue?vue&type=script&lang=js&"
import style0 from "./CollectionVideoPreview.vue?vue&type=style&index=0&id=917ad63e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "917ad63e",
  null
  
)

export default component.exports